export default __webpack_public_path__ + "static/media/subLogo.93224456.svg";